export const dataLayerEvent = (eventName, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(Object.assign({'event': eventName}, params));
}